"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  element: {
    all: 'unset'
  },
  wrapper: {
    padding: '20px',
    display: 'flex'
  },
  closeBtn: {
    color: _theme.default.palette.primary.light,
    minWidth: 'auto',
    minHeight: 'auto',
    height: '20px',
    padding: 0,
    position: 'absolute',
    right: '20px',
    top: '17px',
    '&:hover': {
      background: 'transparent'
    },
    '& svg': {
      width: '20px',
      height: '20px'
    }
  }
});
var _default = exports.default = useStyles;